import axios from '@/services/ProductService/productInstance'

export default async function deleteViewProfile(id: string) {
  try {
    const res = await axios.delete(`/view-profiles/${id}`)
    return res
  } catch {
    return null
  }
}
